import { useState, useRef } from "react";
import { Volume2, Loader2 } from "lucide-react";

const API_BASE = "http://localhost:8765";

interface Props {
  text: string;
  voice?: string;
  speed?: string;
}

export function TTSButton({ text, voice = "zh-CN-XiaoxiaoNeural", speed = "+0%" }: Props) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const audioRef = useRef<HTMLAudioElement | null>(null);

  async function handlePlay() {
    if (loading) return;
    setLoading(true);
    setError("");

    try {
      const formData = new FormData();
      formData.append("text", text);
      formData.append("voice", voice);
      formData.append("speed", speed);

      const res = await fetch(`${API_BASE}/api/tts`, {
        method: "POST",
        body: formData,
      });

      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.detail || "TTS 请求失败");
      }

      const blob = await res.blob();
      const url = URL.createObjectURL(blob);

      if (audioRef.current) {
        audioRef.current.pause();
        URL.revokeObjectURL(audioRef.current.src);
      }

      const audio = new Audio(url);
      audioRef.current = audio;
      audio.onended = () => {
        URL.revokeObjectURL(url);
        audioRef.current = null;
      };
      await audio.play();
    } catch (e: unknown) {
      setError(e instanceof Error ? e.message : "播放失败");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="inline-flex items-center">
      <button
        onClick={handlePlay}
        disabled={loading}
        className="p-1.5 rounded-lg hover:bg-slate-700/50 transition-colors text-slate-400 hover:text-rose-400 disabled:opacity-50"
        title="朗读此消息"
      >
        {loading ? (
          <Loader2 className="w-4 h-4 animate-spin" />
        ) : (
          <Volume2 className="w-4 h-4" />
        )}
      </button>
      {error && (
        <span className="text-[10px] text-red-400 ml-1">{error}</span>
      )}
    </div>
  );
}
